import { render } from "./AnnouncementMedia.vue?vue&type=template&id=71207f48"
import script from "./AnnouncementMedia.vue?vue&type=script&lang=js"
export * from "./AnnouncementMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__